import { jsx } from "react/jsx-runtime";
import { useFunction } from "@project-rouge/rg-three";
import { Plane } from "@react-three/drei";
import { memo } from "react";
import { MathUtils } from "three";
const clickMaxDist = 3;
const OutClick = memo(({
  onClick
}) => {
  const _onClick = useFunction((e) => {
    if (e.delta > clickMaxDist)
      return;
    e.stopPropagation();
    onClick();
  });
  return /* @__PURE__ */ jsx(
    Plane,
    {
      args: [1e3, 1e3],
      rotation: [-90 * MathUtils.DEG2RAD, 0, 0],
      onClick: _onClick,
      visible: false
    }
  );
});
OutClick.displayName = "OutClick";
export {
  OutClick
};
//# sourceMappingURL=index171.js.map
